import React from 'react';
import { useSidebarState } from '../../../hooks/useSidebarState';
import { motion } from 'framer-motion';

export const SidebarLogo = () => {
  const { isCollapsed } = useSidebarState();

  return (
    <motion.div
      className="flex justify-center mb-8"
      animate={{ opacity: isCollapsed ? 0 : 1 }}
      transition={{ duration: 0.2 }}
    >
      <img
        src="https://i.ibb.co/TBjqHtnV/logo-dark.png"
        alt="إثراء الخير"
        className={`h-16 transition-all duration-300 ${
          isCollapsed ? 'scale-0' : 'scale-100'
        }`}
      />
    </motion.div>
  );
};
